module.exports = __webpack_public_path__ + "img/sc-rule-bg.8f01e009.png";